import { Actions } from "../constant";

export const logout = () => ({ type: Actions.LOGOUT });
export const login = email => ({ type: Actions.LOGIN, email });
export const loginFail = reason => ({ type: Actions.LOGIN_FAIL, reason });

export const creatingToken = () => ({ type: Actions.CREATING_TOKEN });
export const createTokenSucc = () => ({ type: Actions.CREATE_TOKEN_SUCC });
export const createTokenFail = result => ({ type: Actions.CREATE_TOKEN_FAIL, result });
